<template>
  <v-dialog v-model="isOpen" persistent max-width="920">
  <v-card class="align-center text-center">
    <div class="pt-5 d-flex align-center justify-space-between px-3">
      <div class="d-flex pl-2">
        <h1>Detalhes de erros no agrupamento e alocação de cargas</h1>
      </div>
      <v-btn icon @click="$emit('update:isOpen'), $emit('cancelClick')" class="align-self-end">
        <v-icon> mdi-close </v-icon>
      </v-btn>
    </div>
    <v-card-text class="d-flex align-center text-left px-2">
      <div class="ctes-container">
        <section class="section-style border-tab no-border">
          <div>
            <div class="mt10"></div>
            <v-simple-table class="w-100 table-data-errors" fixed-header height="400">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">NÚMERO DA PARADA</th>
                    <th class="text-left">ERROS</th>
                    <th class="text-left">TRANSBORDOS</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="dataErrors.length > 0">
                    <tr class="text-left" v-for="errorsItem of dataErrors" :key="errorsItem.line">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <td class="text-truncate" v-bind="attrs" v-on="on">
                            {{ truncateText(formatStopNumbers(errorsItem.stopNumber)) }}
                          </td>
                        </template>
                        <span style="display: inline-block; max-width: 40ch; word-break: break-word">
                          {{ formatStopNumbers(errorsItem.stopNumber) }}
                        </span>
                      </v-tooltip>
                      <td>
                        {{ errorsItem.error }}
                      </td>
                      <v-tooltip v-if="errorsItem.transshipments" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <td class="text-truncate" v-bind="attrs" v-on="on">
                            {{
                              errorsItem.transshipments
                                ? truncateText(formatTransshipments(errorsItem.transshipments, 40))
                                : ''
                            }}
                          </td>
                        </template>
                        <span
                          v-if="errorsItem.transshipments"
                          v-html="formatTransshipments(errorsItem.transshipments, true)"
                        ></span>
                      </v-tooltip>
                      <td v-else class="text-truncate"></td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="7" class="text-center">Nenhuma parada alocado para essa carga</td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </section>
      </div>
    </v-card-text>
  </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isOpen: {
      default: true,
      type: Boolean
    },
    dataErrors: {
      type: Array,
      default: () => []
    },
    confirmButtonText: {
      default: 'Confirmar',
      type: String
    },
    confirmText: {
      default: 'Confirmar',
      type: String
    },
    bodyText: {
      default: 'entregas',
      type: String
    },
    isConfirmBtnLoading: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    truncateText(text, limit = 20) {
      if (Array.isArray(text)) {
        text = text.join(', ');
      }
      if (typeof text === 'string') {
        return text.length > limit ? text.substring(0, limit) + '...' : text;
      }
      return '';
    },
    formatStopNumbers(array) {
      if (Array.isArray(array)) {
        return array.join(', ');
      }
      return '';
    },
    formatTransshipments(namesString, br = true) {
      const namesArray = namesString.split(',').map((name) => name.trim());
      if (namesArray.length > 0) {
        let formattedString = '';
        for (let i = 0; i < namesArray.length; i++) {
          formattedString += namesArray[i];
          if (br && i + 1 < namesArray.length) {
            formattedString += ',<br/>';
          }
        }
        return formattedString.trim();
      }
      return '';
    }
  }
};
</script>

<style lang="scss" scoped>
.ctes-container {
  width: 100%;
  height: auto;
  max-height: 540px;
  overflow-y: auto;
  overflow-x: hidden;
}
::v-deep .table-data-errors.v-data-table.v-data-table--fixed-header thead th {
  background-color: #e0e0e0 !important;
  border: 1px solid #e0e0e0;
  z-index: auto;
}
</style>
